import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./HomePage.css";
import { Dialog } from "primereact/dialog";
import { Knob } from "primereact/knob";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../utils/Guard";
import { GetSigns } from "../../store/sign-store/sign-actions";
import ABADatatable from "../../components/ABADataTable/ABADatatable";
import { Button } from "primereact/button";
import { GetUserInfo } from "../../store/user-store/user-actions";
import { GetStatusInfo } from "../../store/status-store/status-actions";

const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const signs = useSelector((state) => state.sign.signs);
  const [visibleApproved, setVisibleApproved] = useState(false);
  const [visibleDenied, setVisibleDenied] = useState(false);
  const [visibleOnboardingDenied, setVisibleOnboardingDenied] = useState(false);
  const [visiblePendingApprovation, setVisiblePendingApprovation] = useState(false);
  const [visiblePendingOnboarding, setVisiblePendingOnboarding] = useState(false);
  const [completeSigns, setCompleteSigns] = useState([]);

  useEffect(() => {
    if (
      userInfo !== undefined &&
      userInfo !== null &&
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("sign.showAll") &&
      signs !== undefined &&
      signs.length === 0
    ) {
      dispatch(GetSigns(userInfo.Email));
    }
  }, [dispatch]);


  useEffect(() => {
    if (
      completeSigns !== null &&
      completeSigns !== undefined &&
      completeSigns.length > 0
    ) {
      let approvedSigns = [];
      let deniedSigns = [];
      let onboardingDeniedSigns = [];
      let pendingApprovationSigns = [];
      let pendingOnboardingSigns = [];

      completeSigns.forEach((sign) => {
        if (sign.digitalSignStatusId === 1) {
          pendingOnboardingSigns.push(sign);
        }
        if (sign.digitalSignStatusId === 2) {
          pendingApprovationSigns.push(sign);
        }
        if (sign.digitalSignStatusId === 3) {
          onboardingDeniedSigns.push(sign);
        }
        if (sign.digitalSignStatusId === 4) {
          approvedSigns.push(sign);
        }
        if (sign.digitalSignStatusId === 5) {
          deniedSigns.push(sign);
        }
      });

      
    }
  }, [signs]);

  useEffect(() => {
    if (completeSigns.length === 0 && signs !== undefined && signs.length > 0) {
      let cp = [];
      signs.forEach(async (sign) => {
        var representative = await dispatch(
          GetUserInfo(sign.representativeId, userInfo.Email)
        );
        var belonging = await dispatch(
          GetUserInfo(sign.belongingId, userInfo.Email)
        );
        var status = await dispatch(
          GetStatusInfo(sign.digitalSignStatusId, userInfo.Email)
        );

        cp.push({
          ...sign,
          representative: representative,
          belonging: belonging,
          digitalSignRegisterStatus: status,
        });

        if (cp.length === signs.length) {
          setCompleteSigns(cp);
        }
      });

      setCompleteSigns(signs);
    }
  }, [completeSigns, dispatch, signs]);
  
  const statusBody = (rowData) => {
    if (
      rowData.digitalSignRegisterStatus !== undefined &&
      rowData.digitalSignRegisterStatus !== null &&
      rowData.digitalSignRegisterStatus.name !== undefined &&
      rowData.digitalSignRegisterStatus.name !== null &&
      rowData.digitalSignRegisterStatus.name !== ""
    ) {
      const color = rowData.digitalSignRegisterStatus.color;
      return (
        <span style={{ color: color, fontWeight: "bold" }}>
          {rowData.digitalSignRegisterStatus.name}
        </span>
      );
    } else {
      return (
        <i className="pi pi-spin pi-spinner" style={{ fontSize: "1rem" }}></i>
      );
    }
  };

  const columns = [
    {
      field: "pk",
      header: "Pk",
      filterMatchMode: "contains",
    },

    {
      field: "instance",
      header: "Instancia",
      filterMatchMode: "contains",
    },
    {
      field: "representative.name",
      header: "Solicitado por",
      filterMatchMode: "contains",
      body: (rowData) => {
        if (
          rowData.representative !== undefined &&
          rowData.representative !== null &&
          rowData.representative.name !== undefined &&
          rowData.representative.name !== null &&
          rowData.representative.name !== ""
        ) {
          return (
            rowData.representative.name + " " + rowData.representative.surname1
          );
        } else {
          return (
            <i
              className="pi pi-spin pi-spinner"
              style={{ fontSize: "1rem" }}
            ></i>
          );
        }
      },
    },
    {
      field: "belonging.name",
      header: "Para",
      filterMatchMode: "contains",
      body: (rowData) => {
        if (
          rowData.belonging !== undefined &&
          rowData.belonging !== null &&
          rowData.belonging.name !== undefined &&
          rowData.belonging.name !== null &&
          rowData.belonging.name !== ""
        ) {
          return rowData.belonging.name + " " + rowData.belonging.surname1;
        } else {
          return (
            <i
              className="pi pi-spin pi-spinner"
              style={{ fontSize: "1rem" }}
            ></i>
          );
        }
      },
    },
    {
      field: "digitalSignRegisterStatus.name",
      header: "Estado",
      filterMatchMode: "contains",
      body: statusBody,
    },
  ];

  const selectHanlder = (val) => {
    if (val === undefined || val === null)
    {
    navigate(`/sign/${val.id}/request/create`);
    }
  };

  const backHanlder = () => {
    navigate(`/sign`);
  };
  const viewDetailHanlder = (val) => {
    navigate(`/sign/detail/${val.pk}`);
  };

  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Seleccionar"
        icon="pi pi-chevron-circle-right"
        className="p-button-rounded p-button-text"
        onClick={() => {
          selectHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );

    if (userInfo.Roles !== undefined && userInfo.Roles.includes("sign.view")) {
      buttons.push(buttonView);
    }
  
    return buttons;
  };
  actions.push(buttons);
  return (
    <>
   

      <div className="homeTitle">Bienvenido a Firma Digital</div>
      {signs !== undefined && signs !== null && (
      <div className="knobContainer">
        <div
          className="knob-container"
          onClick={() => 
            signs.filter((sign)=>sign.digitalSignStatusId===4).length > 0 ?
            setVisibleApproved(true) : null
          }
        >
          <Knob
            value={signs.filter((sign)=>sign.digitalSignStatusId===4).length}
            min={0}
            max={signs.length}
            size={200}
            readOnly
          />

          <div className="knob-title">Firmas aprobadas</div>
        </div>
        <div className="knob-container" onClick={() => 
            signs.filter((sign)=>sign.digitalSignStatusId===5).length > 0 ?
            setVisibleDenied(true) : null
        }>
          <Knob
            value={signs.filter((sign)=>sign.digitalSignStatusId===5).length}
            size={200}
            max={signs.length}
            readOnly
          />
          <div className="knob-title">Firmas denegadas</div>
        </div>
        <div
          className="knob-container"
          onClick={() => 
            signs.filter((sign)=>sign.digitalSignStatusId===3).length > 0 ?
            setVisibleOnboardingDenied(true) : null
          }
        >
          <Knob
            value={signs.filter((sign)=>sign.digitalSignStatusId===3).length}
            max={signs.length}
            size={200}
            readOnly
          />
          <div className="knob-title">Onboarding denegado</div>
        </div>
        <div
          className="knob-container"
          onClick={() => 
            signs.filter((sign)=>sign.digitalSignStatusId===2).length > 0 ?
            setVisiblePendingApprovation(true) : null
          }
        >
          <Knob
            value={signs.filter((sign)=>sign.digitalSignStatusId===2).length}
            max={signs.length}
            size={200}
            readOnly
          />
          <div className="knob-title">Pendientes de aprobación</div>
        </div>
        <div
          className="knob-container"
          onClick={() => 
            signs.filter((sign)=>sign.digitalSignStatusId===1).length > 0 ?
            setVisiblePendingOnboarding(true) : null
          }
        >
          <Knob
            value={signs.filter((sign)=>sign.digitalSignStatusId===1).length}
            max={signs.length}
            size={200}
            readOnly
          />
          <div className="knob-title">Pendientes de onboarding</div>
        </div>
      </div>)}
      <Dialog
        header="Firmas aprobadas"
        visible={visibleApproved}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visibleApproved) return;
          setVisibleApproved(false);
        }}
      >
        <p className="m-0">
          <ABADatatable
            width="0%"
            title="Firmas"
            values={completeSigns.filter((sign)=>sign.digitalSignStatusId===4)}
            rows={5}
            rowsPerPageOptions={[5, 10, 20]}
            Columns={columns}
            actions={actions}
            createButton={{
              undefined,
            }}
            backButton={{
              label: "Regresar",
              onClick: backHanlder,
              permission: "goBack",
            }}
          />
        </p>
      </Dialog>
      <Dialog
        header="Firmas Denegadas"
        visible={visibleDenied}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visibleDenied) return;
          setVisibleDenied(false);
        }}
      >
        <p className="m-0">
          <ABADatatable
            width="0%"
            title="Firmas"
            values={completeSigns.filter((sign)=>sign.digitalSignStatusId===5)}
            rows={5}
            rowsPerPageOptions={[5, 10, 20]}
            Columns={columns}
            actions={actions}
            createButton={{
              undefined,
            }}
            backButton={{
              label: "Regresar",
              onClick: backHanlder,
              permission: "goBack",
            }}
          />
        </p>
      </Dialog>
      <Dialog
        header="Onboarding denegado"
        visible={visibleOnboardingDenied}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visibleOnboardingDenied) return;
          setVisibleOnboardingDenied(false);
        }}
      >
        <p className="m-0">
          <ABADatatable
            width="0%"
            title="Firmas"
            values={completeSigns.filter((sign)=>sign.digitalSignStatusId===3)}
            rows={5}
            rowsPerPageOptions={[5, 10, 20]}
            Columns={columns}
            actions={actions}
            createButton={{
              undefined,
            }}
            backButton={{
              label: "Regresar",
              onClick: backHanlder,
              permission: "goBack",
            }}
          />
        </p>
      </Dialog>
      <Dialog
        header="Firmas pendientes de aprobación"
        visible={visiblePendingApprovation}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visiblePendingApprovation) return;
          setVisiblePendingApprovation(false);
        }}
      >
        <p className="m-0">
          <ABADatatable
            width="0%"
            title="Firmas"
            values={completeSigns.filter((sign)=>sign.digitalSignStatusId===2)}
            rows={5}
            rowsPerPageOptions={[5, 10, 20]}
            Columns={columns}
            actions={actions}
            createButton={{
              undefined,
            }}
            backButton={{
              label: "Regresar",
              onClick: backHanlder,
              permission: "goBack",
            }}
          />
        </p>
      </Dialog>
      <Dialog
        header="Firmas pendientes de onboarding"
        visible={visiblePendingOnboarding}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visiblePendingOnboarding) return;
          setVisiblePendingOnboarding(false);
        }}
      >
        <p className="m-0">
          <ABADatatable
            width="0%"
            title="Firmas"
            values={completeSigns.filter((sign)=>sign.digitalSignStatusId===1)}
            rows={5}
            rowsPerPageOptions={[5, 10, 20]}
            Columns={columns}
            actions={actions}
            createButton={{
              undefined,
            }}
            backButton={{
              label: "Regresar",
              onClick: backHanlder,
              permission: "goBack",
            }}
          />
        </p>
      </Dialog>

    </>
  );
};
export default HomePage;
